import { useAppStore } from "@/lib/store";
import { Button } from "@/components/ui/button";

export function LanguageToggle() {
  const lang = useAppStore((s) => s.lang);
  const toggleLang = useAppStore((s) => s.toggleLang);

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={() => {
        toggleLang();
        if (typeof document !== "undefined") {
          document.documentElement.lang = lang === "en" ? "bn" : "en";
        }
      }}
      className="group h-9 gap-1 px-3 font-semibold hover:bg-accent hover:text-white"
      aria-label="Toggle language"
    >
      <span className={`group-hover:text-white ${lang === "en" ? "text-accent" : "text-muted-foreground"}`}>EN</span>
      <span className="text-muted-foreground group-hover:text-white">|</span>
      <span className={`font-bn group-hover:text-white ${lang === "bn" ? "text-accent" : "text-muted-foreground"}`}>বাং</span>
    </Button>
  );
}
